// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconAttachmentPath = 'M6.6 18.968a5.619 5.619 0 0 1-3.358-1.105 5.496 5.496 0 0 1-2.19-3.693 5.47 5.47 0 0 1 1.113-4.127l3.2-4.299a3.517 3.517 0 0 1 4.88-.656 3.422 3.422 0 0 1 1.345 2.3 3.409 3.409 0 0 1-.694 2.561l-2.878 3.9-1.61-1.185L9.3 8.747a1.45 1.45 0 0 0-.262-2.068 1.501 1.501 0 0 0-2.081.271l-3.2 4.3a3.505 3.505 0 0 0-.723 2.651 3.512 3.512 0 0 0 1.4 2.361c1.587 1.176 3.853.868 5.053-.69 1.211-1.572 2.48-3.24 3.758-4.923 1.117-1.472 2.24-2.952 3.34-4.385a2.005 2.005 0 0 0-.32-2.774 2.08 2.08 0 0 0-2.914.261l-.692.827L11.123 3.3l.695-.828a4.085 4.085 0 0 1 5.725-.515 3.99 3.99 0 0 1 .63 5.521c-1.097 1.43-2.22 2.908-3.335 4.376a902.212 902.212 0 0 1-3.765 4.936A5.638 5.638 0 0 1 6.6 18.97Z';
var IconAttachment = baseIcon('IconAttachment', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconAttachmentPath
});
export default IconAttachment;
//# sourceMappingURL=index.js.map